import { doc, getDoc, where } from "firebase/firestore";
import { db } from "../../../firebase";

const GetSingleTransport = async (TransportID) => {
  try {
    const TransportDocument = doc(db, "Transports", TransportID);
    const TransportsSnapshot = await getDoc(
      TransportDocument,
      where("IsDeleted", "==", false)
    );

    let Transport = { ...TransportsSnapshot.data(), id: TransportsSnapshot.id };

    return Transport;
  } catch (error) {
    console.log(error);
  }
};

export default GetSingleTransport;
